import {Component, ElementRef, inject, ChangeDetectionStrategy} from '@angular/core';
import {IE3InputDeclareTranshipment} from "@portbase/bezoekschip-service-typescriptmodels";
import {checkValidity, sendCommand} from "../../../../common/utils";
import {AppContext} from "../../../../app-context";

@Component({
    selector: 'app-declare-transhipment-container-consignment',
    templateUrl: './declare-transhipment-container-consignment.component.html',
    styleUrls: ['./declare-transhipment-container-consignment.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeclareTranshipmentContainerConsignmentComponent {
  private element: ElementRef = inject(ElementRef);

  crn: string;
  consignmentNumber: string;
  containerNumber: string;

  reset() {
    this.crn = '';
    this.containerNumber = '';
    this.consignmentNumber = '';
  }

  submit() {
    if (checkValidity(this.element)) {
      const declaration = <IE3InputDeclareTranshipment>{
        consignmentNumber: this.consignmentNumber,
        containerNumber: this.containerNumber,
        crn: this.crn
      }

      sendCommand(
        'com.portbase.bezoekschip.common.api.consignments.commands.input.InputDeclareTranshipment', declaration,
        () => AppContext.registerSuccess("Declaration transhipment sent successfully"));
    }
  }
}
